import { useMemo } from 'react';
import { difference, without } from 'lodash';

import { isCustomerFeatureEnabled } from 'src/data/customer';
import {
  doesToolSupportPromptInstruction,
  GENERATION_TOOL,
  GENERATION_TOOL_DD,
  GENERATION_TOOL_FREESTYLE,
  GENERATION_TOOL_GROUP,
  isFreestyleGenerationTool,
  TOOL_GROUPS,
} from 'src/data/generationTool';
import { BE_CUSTOMER_FEATURES } from 'src/lib/featureFlags';
import { useCurrentCustomer } from 'src/store';

import { SIDEBAR_TOOL_GROUPS } from '../ProjectDocumentView/const';

export const useFilteredTools = () => {
  const customer = useCurrentCustomer();

  const hasImageGenerationFeatureFlag = isCustomerFeatureEnabled(
    customer,
    BE_CUSTOMER_FEATURES.imageGeneration
  );

  const orderedTools = () => {
    const TOOLS_TO_SELECT_FROM = without(
      [GENERATION_TOOL_FREESTYLE.freestyle, ...Object.values(GENERATION_TOOL_DD)],
      !hasImageGenerationFeatureFlag ? GENERATION_TOOL.imageWithDescription : null
    );

    const MORE_TOOL_GROUPS = difference(Object.values(GENERATION_TOOL_GROUP), SIDEBAR_TOOL_GROUPS);
    const sidebarOrderedTools = [];
    for (const toolGroup of [...SIDEBAR_TOOL_GROUPS, ...MORE_TOOL_GROUPS]) {
      for (const tool of TOOL_GROUPS.get(toolGroup)) {
        sidebarOrderedTools.push(tool);
      }
    }

    return TOOLS_TO_SELECT_FROM.sort((a, b) => {
      return sidebarOrderedTools.indexOf(a) - sidebarOrderedTools.indexOf(b);
    });
  };

  const filteredTools = without(orderedTools(), GENERATION_TOOL.emailBody).filter(
    (tool) => doesToolSupportPromptInstruction(tool) || isFreestyleGenerationTool(tool)
  );
  return useMemo(() => filteredTools, [filteredTools]);
};
